import { useContext } from "react";

import {
  Container,
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControlLabel,
  Switch,
} from "@material-ui/core";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";

import { PrescricaoContext } from "../contexts/PrescricaoContext";
import usePrescricaoController from "../controllers/PrescricaoController";

import { PainelContainer } from "../styles/Prescricao";

const ModalPrescricaoCadastro = () => {
  const { handleAddColaborador, clearColaborador } = usePrescricaoController();
  const {
    addColabOpen,
    setAddColabOpen,
    colabNome,
    setColabNome,
    colabEmail,
    setColabEmail,
    colabCPF,
    setColabCPF,
    colabRG,
    setColabRG,
    colabActive,
    setColabActive,
  } = useContext(PrescricaoContext);

  const handleCloseModal = () => {
    setAddColabOpen(false);
    clearColaborador();
  };

  return (
    <>
      <Dialog
        open={addColabOpen}
        maxWidth="md"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          CADASTRO DE COLABORADOR
        </DialogTitle>
        <PainelContainer />

        <Container maxWidth="xl">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={colabActive}
                    onChange={() => setColabActive((current) => !current)}
                    color="primary"
                  />
                }
                label="Ativo"
                labelPlacement="end"
              />
            </Grid>
            <Grid item xs={6}>
              <TextFieldErp
                label="Nome*"
                value={colabNome}
                setValue={setColabNome}
              />
            </Grid>
            <Grid item xs={6}>
              <TextFieldErp
                label="E-mail"
                value={colabEmail}
                setValue={setColabEmail}
              />
            </Grid>
            <Grid item xs={6}>
              <TextFieldErp
                label="CPF"
                value={colabCPF}
                setValue={setColabCPF}
                mask="cpf"
              />
            </Grid>
            <Grid item xs={6}>
              <TextFieldErp
                label="RG"
                value={colabRG}
                setValue={setColabRG}
                mask="rg"
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Btn
              label="Cancelar"
              bgcolor="tertiary"
              onClick={handleCloseModal}
            />
            <Btn label="Salvar" onClick={handleAddColaborador} />
          </DialogActions>
        </Container>
      </Dialog>
    </>
  );
};

export { ModalPrescricaoCadastro };
